define('modules/lp_integration/views/fields_steps',['require','exports','module','base/collectionview','./webservice_fields_step_itemview','./fields_step_empty_view','ldsh!../templates/webservice_fields_steps'],function(require, exports, module){
  "use strict";

  var CollectionView = require("base/collectionview"),
      FieldsStep = require("./webservice_fields_step_itemview"),
      EmptyFieldsStep = require("./fields_step_empty_view");

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/webservice_fields_steps"),
    tagName: "form",
    className: "row",
    itemContainer: "#fields-step",
    itemView: FieldsStep,
    emptyViewType: EmptyFieldsStep,
    initialize: function(options) {
      this.defaultFields = options.defaultFields || [];
    },
    helpers: function() {
      return {
        defaultFields: this.defaultFields
      };
    },
    onRender: function() {
      this.$el.i18n();
    }
  });
});

